import { LocationRequest } from '@pxtra-client-lib-legacy/gen';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { useStore } from '../../../../../hooks/useStore';
import { DataViewEditBox, useForm } from '../../../../../lib/components';
import { DepartmentDataForm } from './form';

export const DepartmentData = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyStore } = useStore();
  const params = useParams();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const renderEdit = () => {
    return (
      <DepartmentDataForm
        initialValues={{
          name:
            companyStore.departments?.filter((l) => l.id === params.departmentId)[0]?.name || '',
          active:
            companyStore.departments?.filter((l) => l.id === params.departmentId)[0]?.active ||
            false
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (params.departmentId === 'new') {
              await companyStore.createDepartment(values as LocationRequest);
              navigate(-1);
            } else if (params.departmentId) {
              await companyStore.updateDepartmentData(params.departmentId, values);
            }
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };

  useEffect(() => {
    const abortController = new AbortController();

    const fetchDepartments = async () => {
      if (companyStore.departments && companyStore.departments?.length > 0) return;
      try {
        await companyStore.fetchDepartments();
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };
    fetchDepartments();

    return () => abortController.abort();
  }, [companyStore.company?.id]);

  return (
    <DataViewEditBox
      title={t('company:DEPARTMENT', {
        context: params.departmentId === 'new' ? 'new' : undefined
      })}
      view={() => <></>}
      edit={renderEdit}
      canEdit={params.departmentId !== 'new'}
      initMode={'edit'}
      canSubmit={canSubmit}
      onSubmit={() => {
        form.handleSubmit();
        navigate(-1);
      }}
      onCancel={() => {
        form.handleReset();
        navigate(-1);
      }}
    />
  );
});
